import React, { createContext, useContext, useEffect, useState } from "react";
import client from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("t24_token");
    if (!token) {
      setLoading(false);
      return;
    }
    client
      .get("/auth/me")
      .then((res) => setUser(res.data.user))
      .catch(() => localStorage.removeItem("t24_token"))
      .finally(() => setLoading(false));
  }, []);

  const signup = async (payload) => {
    const res = await client.post("/auth/signup", payload);
    localStorage.setItem("t24_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const login = async (email, password) => {
    const res = await client.post("/auth/login", { email, password });
    localStorage.setItem("t24_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("t24_token");
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const res = await client.get("/auth/me");
      setUser(res.data.user);
    } catch (e) {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, signup, login, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};
